/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductConsistency = {
    ProductConsistencyNew: 'new',
    ProductConsistencyUsed: 'used',
    ProductConsistencyLikeNew: 'like_new'
} as const;
export type ProductConsistency = typeof ProductConsistency[keyof typeof ProductConsistency];


export function instanceOfProductConsistency(value: any): boolean {
    for (const key in ProductConsistency) {
        if (Object.prototype.hasOwnProperty.call(ProductConsistency, key)) {
            if (ProductConsistency[key as keyof typeof ProductConsistency] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProductConsistencyFromJSON(json: any): ProductConsistency {
    return ProductConsistencyFromJSONTyped(json, false);
}

export function ProductConsistencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductConsistency {
    return json as ProductConsistency;
}

export function ProductConsistencyToJSON(value?: ProductConsistency | null): any {
    return value as any;
}

export function ProductConsistencyToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductConsistency {
    return value as ProductConsistency;
}

